import { FiChevronRight, FiCheck, FiTarget, FiEye, FiAward, FiUsers } from 'react-icons/fi';

const AboutCompany = () => {
  return (
    <div className="about-company-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="page-header-content">
            <span className="page-subtitle">Company</span>
            <h1 className="page-title">About Us</h1>
            <div className="breadcrumb">
              <a href="#home">Home</a>
              <FiChevronRight />
              <span>About Us</span>
              <FiChevronRight />
              <span>Company</span>
            </div>
          </div>
        </div>
      </div>

      {/* Company Introduction - Image Left, Text Right */}
      <section className="company-intro section">
        <div className="container">
          <div className="company-intro-grid">
            <div className="company-intro-image">
              <div className="image-placeholder large">
                Company Building / Factory Image
              </div>
              <div className="experience-badge">
                <span className="exp-number">10+</span>
                <span className="exp-text">Years in Indonesia</span>
              </div>
            </div>
            <div className="company-intro-content">
              <span className="section-subtitle">Who We Are</span>
              <h2 className="section-title">Shuanghui Power Indonesia</h2>
              <p className="intro-text">
                Shuanghui Power Indonesia adalah perusahaan manufaktur switchgear medium voltage
                yang berdedikasi untuk menyediakan solusi kelistrikan berkualitas tinggi bagi
                industri di Indonesia. Dengan pengalaman lebih dari satu dekade dan didukung
                oleh teknologi dari Shuanghui Group China, kami telah menjadi mitra terpercaya
                bagi berbagai sektor industri.
              </p>
              <p className="intro-text">
                Fasilitas produksi kami yang modern dan tim engineer berpengalaman memungkinkan
                kami untuk menghasilkan produk switchgear yang memenuhi standar internasional
                IEC dengan kualitas yang konsisten dan handal.
              </p>
              <div className="intro-features">
                <div className="intro-feature">
                  <FiCheck className="feature-icon" />
                  <span>Standar Internasional IEC</span>
                </div>
                <div className="intro-feature">
                  <FiCheck className="feature-icon" />
                  <span>Tim Engineer Berpengalaman</span>
                </div>
                <div className="intro-feature">
                  <FiCheck className="feature-icon" />
                  <span>Fasilitas Produksi Modern</span>
                </div>
                <div className="intro-feature">
                  <FiCheck className="feature-icon" />
                  <span>Dukungan Teknis 24/7</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission - Vertical Layout */}
      <section className="vision-mission section bg-light">
        <div className="container">
          <div className="section-header-center">
            <span className="section-subtitle">Our Purpose</span>
            <h2 className="section-title">Vision & Mission</h2>
          </div>

          <div className="vm-vertical-layout">
            {/* Vision Card */}
            <div className="vm-card">
              <div className="vm-card-image">
                <div className="image-placeholder medium">
                  Vision Image - Future Growth
                </div>
              </div>
              <div className="vm-card-content">
                <div className="vm-icon">
                  <FiEye />
                </div>
                <h3>Our Vision</h3>
                <p>
                  Menjadi perusahaan manufaktur switchgear terdepan di Indonesia yang diakui
                  secara global dalam hal inovasi, kualitas, dan kehandalan produk. Kami
                  berkomitmen untuk berkontribusi pada pembangunan infrastruktur kelistrikan
                  nasional yang berkelanjutan.
                </p>
              </div>
            </div>

            {/* Mission Card */}
            <div className="vm-card reverse">
              <div className="vm-card-image">
                <div className="image-placeholder medium">
                  Mission Image - Team Working
                </div>
              </div>
              <div className="vm-card-content">
                <div className="vm-icon">
                  <FiTarget />
                </div>
                <h3>Our Mission</h3>
                <ul className="mission-list">
                  <li>Menyediakan produk switchgear berkualitas tinggi dengan harga kompetitif</li>
                  <li>Memberikan layanan purna jual yang responsif dan profesional</li>
                  <li>Mengembangkan SDM yang kompeten dan berintegritas</li>
                  <li>Menerapkan sistem manajemen mutu yang berkelanjutan</li>
                  <li>Berkontribusi pada pengembangan industri kelistrikan nasional</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Values - Horizontal Image Grid */}
      <section className="company-values section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-subtitle">What We Stand For</span>
            <h2 className="section-title">Our Core Values</h2>
          </div>

          <div className="values-horizontal-grid">
            <div className="value-card">
              <div className="value-image">
                <div className="image-placeholder small">Quality</div>
              </div>
              <div className="value-content">
                <h4>Quality Excellence</h4>
                <p>Komitmen terhadap kualitas produk yang memenuhi standar internasional.</p>
              </div>
            </div>

            <div className="value-card">
              <div className="value-image">
                <div className="image-placeholder small">Innovation</div>
              </div>
              <div className="value-content">
                <h4>Continuous Innovation</h4>
                <p>Selalu berinovasi dalam teknologi dan proses untuk hasil terbaik.</p>
              </div>
            </div>

            <div className="value-card">
              <div className="value-image">
                <div className="image-placeholder small">Integrity</div>
              </div>
              <div className="value-content">
                <h4>Business Integrity</h4>
                <p>Menjalankan bisnis dengan kejujuran dan transparansi.</p>
              </div>
            </div>

            <div className="value-card">
              <div className="value-image">
                <div className="image-placeholder small">Customer</div>
              </div>
              <div className="value-content">
                <h4>Customer Focus</h4>
                <p>Mengutamakan kepuasan dan kebutuhan pelanggan.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section - Mixed Layout */}
      <section className="company-gallery section bg-light">
        <div className="container">
          <div className="section-header-center">
            <span className="section-subtitle">Our Facilities</span>
            <h2 className="section-title">Manufacturing Excellence</h2>
            <p className="section-description center">
              Fasilitas produksi kami dilengkapi dengan peralatan modern dan sistem
              quality control yang ketat untuk memastikan setiap produk memenuhi standar tertinggi.
            </p>
          </div>

          {/* Horizontal Gallery Row */}
          <div className="gallery-horizontal">
            <div className="gallery-item">
              <div className="image-placeholder gallery">Production Line</div>
              <div className="gallery-overlay">
                <span>Production Line</span>
              </div>
            </div>
            <div className="gallery-item">
              <div className="image-placeholder gallery">Assembly Area</div>
              <div className="gallery-overlay">
                <span>Assembly Area</span>
              </div>
            </div>
            <div className="gallery-item">
              <div className="image-placeholder gallery">Testing Lab</div>
              <div className="gallery-overlay">
                <span>Testing Laboratory</span>
              </div>
            </div>
          </div>

          {/* Vertical Gallery with Description */}
          <div className="gallery-vertical-section">
            <div className="gallery-vertical-item">
              <div className="gallery-vertical-image">
                <div className="image-placeholder vertical">Quality Control Room</div>
              </div>
              <div className="gallery-vertical-content">
                <h4>Quality Control</h4>
                <p>
                  Setiap produk melewati serangkaian pengujian ketat di laboratorium QC kami
                  untuk memastikan kualitas dan keamanan sesuai standar IEC.
                </p>
              </div>
            </div>

            <div className="gallery-vertical-item reverse">
              <div className="gallery-vertical-image">
                <div className="image-placeholder vertical">Warehouse</div>
              </div>
              <div className="gallery-vertical-content">
                <h4>Warehouse & Logistics</h4>
                <p>
                  Gudang modern dengan sistem inventory management yang efisien memastikan
                  ketersediaan produk dan pengiriman tepat waktu ke seluruh Indonesia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications & Achievements */}
      <section className="certifications section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-subtitle">Our Achievements</span>
            <h2 className="section-title">Certifications & Standards</h2>
          </div>

          <div className="cert-grid">
            <div className="cert-card">
              <div className="cert-icon">
                <FiAward />
              </div>
              <h4>ISO 9001:2015</h4>
              <p>Quality Management System</p>
            </div>
            <div className="cert-card">
              <div className="cert-icon">
                <FiAward />
              </div>
              <h4>IEC 62271-200</h4>
              <p>MV Switchgear Standard</p>
            </div>
            <div className="cert-card">
              <div className="cert-icon">
                <FiAward />
              </div>
              <h4>SNI Certified</h4>
              <p>Indonesian National Standard</p>
            </div>
            <div className="cert-card">
              <div className="cert-icon">
                <FiAward />
              </div>
              <h4>PLN Approved</h4>
              <p>PLN Vendor Certification</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section
      <section className="team-section section bg-light">
        <div className="container">
          <div className="section-header-center">
            <span className="section-subtitle">Our Team</span>
            <h2 className="section-title">Leadership Team</h2>
          </div>

          <div className="team-grid">
            <div className="team-card">
              <div className="team-image">
                <div className="image-placeholder team">Director Photo</div>
              </div>
              <div className="team-info">
                <h4>John Doe</h4>
                <span className="team-role">President Director</span>
              </div>
            </div>

            <div className="team-card">
              <div className="team-image">
                <div className="image-placeholder team">Manager Photo</div>
              </div>
              <div className="team-info">
                <h4>Jane Smith</h4>
                <span className="team-role">Operations Director</span>
              </div>
            </div>

            <div className="team-card">
              <div className="team-image">
                <div className="image-placeholder team">Engineer Photo</div>
              </div>
              <div className="team-info">
                <h4>Ahmad Wijaya</h4>
                <span className="team-role">Technical Director</span>
              </div>
            </div>

            <div className="team-card">
              <div className="team-image">
                <div className="image-placeholder team">Sales Photo</div>
              </div>
              <div className="team-info">
                <h4>Siti Rahayu</h4>
                <span className="team-role">Sales Director</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Work Together?</h2>
            <p>
              Hubungi tim kami untuk konsultasi kebutuhan switchgear Anda.
              Kami siap memberikan solusi terbaik untuk bisnis Anda.
            </p>
            <div className="cta-buttons">
              <a href="#contact" className="btn btn-primary">Contact Us</a>
              <a href="#products" className="btn btn-outline">View Products</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutCompany;
